import React, { useRef, useState } from "react";
import "../TemplateDriven/dataMapTable.scss";
import { isDisable } from "../TemplateDriven/EditableCellConfig";

const EditableCell = ({
  parameterIndex,
  mapping,
  onClickMapping,
  clearMappings,
  parametersData,
  mappingIndex,
  rowRejectionData,
  role = "preProcessor",
  isDataRejectedByProcessor,
  entireBatchRejectedByPro,
  entireBatchRejectedByVali,
  reProcessEntireBatch,
  reProcess,
  isDataRejectedByValidator,
  reValidate
}) => {
  const textAreaRef = useRef(null);

  const adjustTextareaHeight = () => {
    const textarea = textAreaRef.current;

    if (textarea) {
      textarea.style.height = "auto"; // Reset the height to auto

      const newHeight = textarea.scrollHeight - 3; // Calculate the new height based on content
      // Set the min height (can be any value, here it's an example of 100px)
      const minHeight = 35; // Example min height
      // Set the height to the greater of the scrollHeight or the minHeight
      textarea.style.height = Math.max(newHeight, minHeight) + "px";
    }
  };

  const textValue = (mapping) => {
    let value =
      mapping?.pageNo >= 0 && mapping?.tagName !== ""
        ? `${mapping?.tagName} - ${parseInt(mapping?.pageNo) + 1}`
        : "";

    return value;
  };

  const initialValue = textValue(mapping);

  // Set initial value in state
  const [value, setValue] = useState(textValue);

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // Call the adjustTextareaHeight function when the component mounts
  React.useEffect(() => {
    adjustTextareaHeight();
    // role === "preProcessor" && adjustKeyTextareaHeight();
  }, []);

  // Call the adjustTextareaHeight function whenever the value changes

  React.useEffect(() => {
    adjustTextareaHeight();
  }, [value]);

  // Handler for click events
  const handleClick = (e) => {
    onClickMapping(e, parameterIndex);
  };

  const onCero = (e) => {
    // if (isDataRejectedByProcessor !== true) {
    if (e.keyCode === 8 || e.keyCode === 46) {
      clearMappings(parameterIndex);
    }
    // }
  };

  const styleRejectedCell = (
    mapping,
    mappingIndex,
    rowRejectionData,
    parameterIndex
  ) => {
    let backgroundColor = "#FFFF";

    if (role === "preProcessor") {
      // cell not mapping popup

      // Check if one of the inputs has a value while the other doesn't
      // const keyMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.keyData
      //     ?.pageNo;
      // const valueMappingPageNo =
      //   parametersData[parameterIndex]?.mappings[mappingIndex]?.pageNo;

      // const keyMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]
      //     ?.keyCoordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]
      //       ?.keyCoordinates?.length) ||
      //   0;
      // const valueMappingCoordinatesLength =
      //   (parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates &&
      //     parametersData[parameterIndex]?.mappings[mappingIndex]?.coordinates
      //       ?.length) ||
      //   0;
      // if (
      //   parametersData[parameterIndex]?.mappings[mappingIndex]
      //     ?.forNoPreProMappingDataEntryByPro !== true
      // ) {
      //   if (
      // keyMappingPageNo !== "" &&
      // keyMappingPageNo !== undefined &&
      // keyMappingPageNo !== null &&
      // keyMappingPageNo >= 0 &&
      // valueMappingPageNo === "" ||
      // valueMappingPageNo === undefined ||
      // valueMappingPageNo === null ||
      // (valueMappingPageNo !== "" &&
      //   valueMappingPageNo !== undefined &&
      //   valueMappingPageNo !== null &&
      //   valueMappingPageNo >= 0)
      // &&
      // (
      //   keyMappingPageNo === "" ||
      //   keyMappingPageNo === undefined ||
      //   keyMappingPageNo === null
      // )
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // } else if (
      // (keyMappingPageNo !== "" &&
      //   keyMappingPageNo !== undefined &&
      //   keyMappingPageNo !== null &&
      //   keyMappingPageNo >= 0 &&
      //   keyMappingCoordinatesLength <= 0) ||
      //   valueMappingPageNo !== "" &&
      //   valueMappingPageNo !== undefined &&
      //   valueMappingPageNo !== null &&
      //   valueMappingPageNo >= 0 &&
      //   valueMappingCoordinatesLength <= 0
      // ) {
      //   backgroundColor = "rgb(241 238 137 / 41%)"; // Red background color
      // }
      // }

      // return { backgroundColor };

      // color when row or cell rej by pro
      if (
        mapping?.processorCellRejection?.isRejected ||
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)";
      }

      // dark red color for both rejection in cell and in row
      if (
        mapping?.processorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red color for both rejection in row
      if (
        rowRejectionData &&
        rowRejectionData.length > 0 &&
        rowRejectionData[mappingIndex]?.isRowRejectedByProcessor
      ) {
        backgroundColor = "rgb(253 97 71)";
      }
    }

    return { backgroundColor };
  };


  const isDisableWrapper = (mapping, mappingIndex, parameterIndex) => {
    if (mapping?.isDerivativeField) {
      return true;
    }
    const isDisableFlag = isDisable(
      mapping,
      mappingIndex,
      parameterIndex,
      role,
      isDataRejectedByProcessor,
      entireBatchRejectedByPro,
      parametersData,
      entireBatchRejectedByVali,
      reProcessEntireBatch,
      reProcess,
      isDataRejectedByValidator,
      reValidate
    );
    return isDisableFlag;
  };


  const disableText = isDisable(
    mapping,
    mappingIndex,
    parameterIndex,
    role,
    isDataRejectedByProcessor,
    entireBatchRejectedByPro,
    parametersData,
    entireBatchRejectedByVali,
    reProcessEntireBatch,
    reProcess,
    isDataRejectedByValidator,
    reValidate
  )
    ? true
    : false;
    
  return (
    <div className="cell-main">
      <div
        className="cell-outer"
        style={{
          ...styleRejectedCell(
            mapping,
            mappingIndex,
            rowRejectionData,
            parameterIndex
          ),
          ...{
            padding: "0px 15px 0px 5px",
          },
          // to heighlight selected  cell for re initiate vlm

          ...(mapping?.reInitiateProVlm && {
            border: "2px solid #2776d2", // Example for "selected for reprocess"
          }),
        }}
      >
        <textarea
          onKeyDown={(e) => onCero(e)}
          ref={textAreaRef}
          // className="my-textarea"
          id="outlined-basic"
          className={` ${
            role === "preProcessor" ? "my-textarea-min-height" : "my-textarea"
          } ${
            disableText
              ? "disableCell"
              : role === "validator"
              ? "disable_opacity"
              : ""
          }`}
          style={{
            minHeight: "100%",
            width: "100%",
            resize: "none",
            overflow: "hidden",
            backgroundColor: "transparent",
          }}
          value={value}
          onClick={handleClick}
          rows={1}
          readOnly
          disabled={isDisableWrapper(
            mapping,
            mappingIndex,
            parameterIndex
          )}
        />
      </div>
    </div>
  );
};

export default EditableCell;
